module.exports = __webpack_public_path__ + "img/684-f471b2.png";